module.exports = __webpack_public_path__ + "img/scheepsbrug.29b68557.png";